module.exports = __webpack_public_path__ + "img/Check.6332a16d.svg";